import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "gdprWrap",
  class: "flex center align-center"
}
const _hoisted_2 = {
  id: "gdpr-wrapper",
  class: "box-shadow bc-red reversed nohover"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "We are using cookies to give you the best experience on our website.", -1)
const _hoisted_4 = {
  id: "btn-wrapper",
  class: "flex center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Decline", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Accept", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx, _cache) {
  return (!_ctx.close)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              href: "",
              class: "btn red bc-red border auto",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeBox(false,$event)))
            }, _hoisted_6),
            _createElementVNode("a", {
              href: "",
              class: "btn red bc-red border auto",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.closeBox(true,$event)))
            }, _hoisted_8)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}